const packageDetailsContentMap: Map<string, string[]> = new Map([
	// Skipass, equipment and train
	["PFTT", ["planner_info_pack_train_skipass_equipment"]],
	["PFTT_7", ["planner_info_pack_train_7"]],
	["PFTT_8", ["planner_info_pack_train_8"]],
	["PFTTF", ["planner_info_pack_train_skipass_equipment"]],
	["PFPTT", ["planner_info_pack_train_skipass_equipment"]],
	["PFPTTF", ["planner_info_pack_train_skipass_equipment"]],
	// Skipass, accommodation
	["PF", ["planner_info_pack_equipment"]],
	["PFPCS", ["planner_info_pack_skipass_equipment"]],
	// Skipass, accommodation, equipment
	["PFCS", ["planner_info_pack_equipment"]],
	["PFP", ["planner_info_pack_skipass_equipment"]],
	["PFPF", ["planner_info_pack_skipass_equipment"]],
	["PFF", ["planner_info_pack_skipass_equipment"]],
]);


export default packageDetailsContentMap